import { Dispatch } from 'redux';

import { AppThunk } from '.';
import * as actionTypes from './actionTypes';

import { FeatureFlagsActions } from '../../types/actiontypes/featureFlagsActions';
import { FeatureFlags } from '../../utils/constants';
import { devLogger, getFeatureFlags } from '../../utils';

export const createSetFeatureFlagsAction = (featureFlags: FeatureFlags): FeatureFlagsActions => ({
  type: actionTypes.FEATURE_FLAGS_SET,
  featureFlags: featureFlags,
});

export const setFeatureFlags = (): AppThunk<Promise<void>> => async (dispatch: Dispatch) => {
  const featureFlagsResponse = await getFeatureFlags();
  if (featureFlagsResponse) {
    dispatch(createSetFeatureFlagsAction(featureFlagsResponse.featureFlags));
    return;
  }
  devLogger('Failed to set feature flags - features behind feature flags not available');
};
